<template>
  <div id="mapa-financeiro">
    <div class="w3-row-padding row-mapa-financeiro">

      <div v-cloak class="w3-panel w3-theme w3-card" v-if="processando">
      <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
      
      <div class="w3-card card-pedido-bloqueado" v-cloak>
      <div class="w3-container w3-white w3-border">
        <div class="w3-row-padding" style="padding:0">

          <div class="dados_mapa w3-row">
            <div class="w3-col l12 box-contas">
              <div class="w3-col s12" >
                  <strong class="w3-text-theme w3-large w3-col s12" style="padding:4px 8px!important;">Contas a receber</strong>
                  <div class="w3-col s12 m12 l6" style="padding:4px 8px!important;" v-for="conta_receber in dados.contas_receber" v-if="dados.contas_receber.length > 0 && expandido">
                    <label class="w3-col s12 m12 l6" style="line-height: 35px; border-bottom: 1px solid black">{{conta_receber.portador_nome}}</label>
                    <strong class=" w3-large w3-col s12 m12 l6" style="line-height: 35px;text-align: right; border-bottom: 1px solid black">R$ {{conta_receber.total}}</strong>
                  </div>
                  <div style="padding:4px 8px!important;" v-if="dados.contas_receber.length == 0">
                    Não há dados a serem exibidos.
                  </div>
              </div>

              <div class="w3-col s12 w3-margin-top" > 
                <div class="w3-col s12 l4 " style="text-align: center;">
                  <label class="w3-col s12" >Total</label>
                  <strong class=" w3-large w3-col s12" style="line-height: 35px; ">R$ {{ formatarValor(dados.soma_contas_receber, 2) }}</strong>
                </div>

                <div class="w3-col s12 l4" style="text-align: center;">
                  <label class="w3-col s12">Previsões de venda</label>
                  <strong class=" w3-large w3-col s12" style="line-height: 35px; ">R$ {{ dados.previsoes_venda }}</strong>
                </div>
                <div class="w3-col s12 l4" style="text-align: center;">
                  <label class="w3-col s12" >Total a receber</label>
                  <strong class=" w3-large w3-col s12" style="line-height: 35px; ">R$ {{
                      formatarValor(dados.total_a_receber, 2)                 
                    }}</strong>
                  <hr>
                </div>
               </div>
            </div><!-- w3-col -->

            <div class="w3-col l12 box-contas w3-margin-top">
              <div class="w3-col s12">
                <strong class="w3-text-theme w3-large w3-col s12" style="padding:4px 8px!important;">Contas a pagar</strong>
                <div class="w3-col s12 m12 l6" style="padding:4px 8px!important;" v-for="(conta_pagar, index) in dados.contas_pagar" v-if="dados.contas_pagar.length > 0 && expandido">
                  <label class="w3-col s12 m12 l6" style="line-height: 35px; border-bottom: 1px solid black">{{conta_pagar.plano_financeiro_nome}}</label>
                  <strong class=" w3-large w3-col s12 m12 l6" style="line-height: 35px;text-align: right; border-bottom: 1px solid black">R$ {{conta_pagar.total}}</strong>
                </div>
                <div style="padding:4px 8px!important;" v-if="dados.contas_pagar.length == 0">
                  Não há dados a serem exibidos.
                </div>
              </div>

              <div class="w3-col s12 w3-margin-top l6" style="padding:4px 8px!important;" v-if="dados.previsoes_pagar.length != 0">
                <label class="w3-col s12 m12 l6" style="line-height: 35px; border-bottom: 1px solid black">Total</label>
                <strong class=" w3-large w3-col s12 m12 l6" style="line-height: 35px;text-align: right; border-bottom: 1px solid black">R$ {{ formatarValor(dados.soma_contas_pagar, 2) }}</strong >
                <hr>
              </div>
            </div><!-- w3-col -->

            <div class="w3-col l12 box-contas w3-margin-top">
              <div class="w3-col s12 ">
                  <strong class="w3-text-theme w3-large w3-col s12" style="padding:4px 8px!important;">Previsões a pagar</strong>
                  <div class="w3-col s12 m12 l6" style="padding:4px 8px!important;" v-for="previsao_pagar in dados.previsoes_pagar" v-if="dados.previsoes_pagar.length > 0 && expandido">
                    <label class="w3-col s12 m12 l6" style="line-height: 35px; border-bottom: 1px solid black">{{previsao_pagar.plano_financeiro_nome}}</label>
                    <strong class=" w3-large w3-col s12 m12 l6" style="line-height: 35px;text-align: right; border-bottom: 1px solid black">R$ {{previsao_pagar.total}}</strong>
                  </div>
                  <div style="padding:4px 8px!important;" v-if="dados.previsoes_pagar.length == 0">
                    Não há dados a serem exibidos.
                  </div>
              </div>

              <div class="w3-col s12 w3-margin-top l6" style="padding:4px 8px!important;" v-if="dados.previsoes_pagar.length != 0">
                <label class="w3-col s12 m12 l6" style="line-height: 35px; border-bottom: 1px solid black">Total</label>
                <strong class=" w3-large w3-col s12 m12 l6" style="line-height: 35px;text-align: right; border-bottom: 1px solid black">R$ {{ formatarValor(dados.soma_previsoes_pagar, 2) }}</strong>
              </div>
            </div><!-- w3-col -->
          </div>
          
        </div><!-- w3-row -->

        <div class="w3-row-padding w3-margin-top">
          <div class="col s12">
            <div class="w3-col s12 l3 " style="text-align: center;">
              <label class="w3-col s12  w3-text">Total a pagar: </label>
              <strong class="w3-large w3-col s12 ">R$ {{ formatarValor(dados.total_pagar, 2) }}</strong>
            </div>
            <div class="w3-col s12 l3 " style="text-align: center;">
              <label class="w3-col s12  w3-text">Total realizado: </label>
              <strong class="w3-large w3-col s12 ">R$ {{ formatarValor(dados.total_realizado, 2) }}</strong>
            </div>
            <div class="w3-col s12 l3 " style="text-align: center;">
              <label class="w3-col s12  w3-text">Total previsto: </label>
              <strong class="w3-large w3-col s12 ">R$ {{ formatarValor(dados.total_previsto, 2) }}</strong>
            </div>
            <div class="w3-col s12 l3 " style="text-align: center;">
              <label class="w3-col s12  w3-text">Total realizado + previsto: </label>
              <strong class="w3-large w3-col s12 "> R$ {{ formatarValor(dados.total_realizado_previsto , 2) }}</strong>
            </div>
            <div class="item w3-col">
              <div class="w3-col s12 l6" style="text-align: center;">
                <label class="w3-col s12 w3-padding-small">Saldo inicial: </label>
                <strong class="w3-large w3-col s12 w3-padding-small">R$ {{ formatarValor(dados.saldo_inicial, 2) }}</strong>
              </div>  
              <div class="w3-col s12 l6" style="text-align: center;">
                <label class="w3-col s12 w3-padding-small">Saldo final: </label>
                <strong class="w3-large w3-col s12 w3-padding-small" style="color:#2e6730">R$ {{ formatarValor(dados.saldo_final, 2) }}</strong>
              </div>         
            </div>                   
          </div><!-- col -->
        </div><!-- row-padding -->     
      </div>
      </div>
    </div>
  </div><!-- mapa-financeiro -->
</template>

<script>
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  export default {
    name: 'MapaFinanceiroCard',
    props: ['dados', 'saldo-inicial'],
    mixins:[formatarValorMixin],
    data() {
      const self = this;
      return {
        api: process.env.API,
        processando: false,
        saldo_inicial: 0,
        expandido: true
      }
    },
    mounted() {

    },
    methods: {
      expandirDados: function() {
        this.expandido = !this.expandido
      },
    },
  }
</script>

<style scoped>
  .dados_mapa {
    margin-top: 20px;
  }

  .texto-responsivo {
    word-break: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
  }

  
  .item{
    border:1px solid #c6c6c6;
    border-radius: 10px;
    overflow:hidden;
    margin-top: 30px;
  }

  .item label{
    background: #f1f1f1;
  }

  .w3-modal-content {
    margin: 0 !important;
    transform: translateX(50%);
  }

  .row-mapa-financeiro{
   padding: 0 
  }
  .divTabelaBloqueios {
    width: 100%;
    float: left;
  }

  .chip-vencimento {
    border-radius: 25px;
    cursor: pointer;
    font-size: .9em;
    padding: 10px 15px;
    text-decoration: underline;
  }

  .card-portador {
    border-left: 3px solid #9c1d1c;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 ;
    padding: 5px 10px;
  }

  .card-portador .w3-text-theme {
    text-transform: uppercase;
  }

  @media(max-width: 992px) {
    .dados_mapa.w3-row-padding {
      padding: 0 !important
    }
    
    .box-contas {
      margin-bottom: 20px
    }

    .box-contas:last-child {
      margin-bottom: 0;
    }
  }
  @media screen and (min-width:1199px){
    .box-contas > div > div{
      display: -webkit-flex;
      -webkit-flex-wrap: wrap;
      display: flex;
      align-content: flex-end;
    }
    .box-contas strong, .box-contas label{
      align-content: flex-end;
    }
  }
  @media(max-width: 500px) {
    .card-pedido-bloqueado .w3-row-padding {
      padding: 0
    }
  }
  .w3-white {
    padding-bottom: 20px;
  }

</style>


// WEBPACK FOOTER //
// src/components/MapaFinanceiroCard.vue